import ValidationMethod from './ValidationMethod';

const required = ({ errorMessage = '' } = {}): ValidationMethod => (v) => !!v || errorMessage;

export { required };
export default required;
